module.exports = __webpack_public_path__ + "kiosk_icon-043c0cfcea13a7019a3b5e213a77b4a9.svg";